import { resetSettings } from 'Settings';

const voltage_options = [
	{ value : 1.2, label: 1.2 },
	{ value : 1.55, label: 1.55 },
	{ value : 1.65, label: 1.65 },
	{ value : 1.8, label: 1.8 },
	{ value : 2, label: 2 },
	{ value : 2.2, label: 2.2 },
	{ value : 2.4, label: 2.4 },
	{ value : 2.6, label: 2.6 },
]

const parseData = (data) => {
	const lines = data.split('\n')

	const lfile = {
		regs : [],
	}

	for (let i = 0; i < 27; ++i)
		lfile.regs.push(parseInt(lines[i].substr(2), 16))
	
	return lfile
}

const LegacyImport = (data, settings) => {
	const { timing, supervisory, vsup, vaux, usb, wakeup } = settings
	const hps = settings['harvester power supervisory']
	const sl = settings['supervisory level']
	const ll = settings['ldo levels']
	const gnd = settings['vaux gnd']

	const leg = parseData(data)

	timing['t_hrv_period'].setValue(2**leg.regs[0] * 256)
	timing['t_hrv_meas'].setValue(2**leg.regs[1] * 16)
	timing['t_sts_period'].setValue(2**leg.regs[2])
	timing['t_lts_period'].setValue(4**leg.regs[3])

	if (leg.regs[4] & 0x40) {
		hps['harvesting element'].setValue('teg')
		leg.regs[4] ^= 0x40
	} else {
		hps['harvesting element'].setValue('solar')
	}

	hps['v_hrv_min'].setValue((leg.regs[4] + 1) * 0.073)

	hps['hrv_check_lvl'].setValue(leg.regs[5] + 1)
	supervisory['battery protector'].setValue(leg.regs[6] === 0)

	sl['v_bat_max_hi'].setValue(leg.regs[7])
	sl['v_bat_max_lo'].setValue(leg.regs[8])
	sl['v_bat_min_hi_dis'].setValue(leg.regs[9])
	sl['v_bat_min_hi_con'].setValue(leg.regs[10])
	sl['v_bat_min_lo'].setValue(leg.regs[11])
	sl['v_apl_max_hi'].setValue(leg.regs[12])
	sl['v_apl_max_lo'].setValue(leg.regs[13])

	vsup['behaviour when disabled'].setValue(leg.regs[14] >> 7)
	ll['v_aux_ldo'].setValue(voltage_options[(leg.regs[14] >> 4) & 0x7])
	vsup['force enable'].setValue(((leg.regs[14] >> 3) & 0x1) === 1)
	ll['v_ulp_ldo'].setValue(leg.regs[14] & 0x7)
	
	usb['always disable usb ldo'].setValue((leg.regs[15] >> 7) === 1)
	gnd[2]['open in hrv_low mode'].setValue((leg.regs[15] >> 6) & 0x1)
	gnd[1]['open in hrv_low mode'].setValue((leg.regs[15] >> 5) & 0x1)
	gnd[0]['open in hrv_low mode'].setValue((leg.regs[15] >> 4) & 0x1)
	vaux[2]['disable in hrv_low mode'].setValue((leg.regs[15] >> 3) & 0x1)
	vaux[1]['disable in hrv_low mode'].setValue((leg.regs[15] >> 2) & 0x1)
	vaux[0]['disable in hrv_low mode'].setValue((leg.regs[15] >> 1) & 0x1)

	vaux[2]['constantly connect to'].setValue(leg.regs[16] >> 4)
	vaux[1]['constantly connect to'].setValue((leg.regs[16] >> 2) & 0x3)
	vaux[0]['constantly connect to'].setValue(leg.regs[16] & 0x3)

	gnd[2]['connection'].setValue(leg.regs[17] >> 4)
	gnd[1]['connection'].setValue((leg.regs[17] >> 2) & 0x3)
	gnd[0]['connection'].setValue(leg.regs[17] & 0x3)

	wakeup['sda'].setValue(leg.regs[19] >> 7)
	wakeup['de-bouncer'].setValue(((leg.regs[19] >> 6) & 0x1) === 1)
	wakeup['edge'].setValue(((leg.regs[19] >> 4) & 0x3) - 1)
	usb['force hrv_low hi-z'].setValue(((leg.regs[19] >> 3) & 0x1) === 1)
	usb['force bat_low hi-z'].setValue(((leg.regs[19] >> 2) & 0x1) === 1)
	usb['charging source'].setValue((leg.regs[19] & 0x2) * 5)

	vsup['sleep'].setValue(leg.regs[20] | (leg.regs[21] << 8) | (leg.regs[22] << 16))

	timing['t_hrv_low_period'].setValue((leg.regs[23] >> 4) ** 2)
	timing['t_lts_hrv_low_period'].setValue(((leg.regs[23] & 0x3) * 2) ** 4)

	wakeup['3 wire interface'].setValue((leg.regs[24] >> 7) === 1)
	wakeup['i2c_address'].setValue((leg.regs[24]) & 0x3f)

	gnd[2]['enable'].setValue((leg.regs[25] >> 6) === 1)
	gnd[1]['enable'].setValue(((leg.regs[25] >> 5) & 0x1) === 1)
	gnd[0]['enable'].setValue(((leg.regs[25] >> 4) & 0x1) === 1)
	vaux[2]['enable'].setValue(((leg.regs[25] >> 3) & 0x1) === 1)
	vaux[1]['enable'].setValue(((leg.regs[25] >> 2) & 0x1) === 1)
	vaux[0]['enable'].setValue(((leg.regs[25] >> 1) & 0x1) === 1)
	vsup['initial state'].setValue(leg.regs[25] & 0x1)

	console.log(settings);
}

export default LegacyImport
